import React from 'react';
import { useGlobalBetslipState } from '@atlas/core';

import { Loader } from '@atlas/ui';

export default function GlobalBetslipLayout({ children }) {
  const { initialized } = useGlobalBetslipState();

  // Handling global betslip initialization
  if (!initialized) {
    return (
      <div className="betslip-loader-container">
        <span>
          <Loader className="absolute" />
        </span>
      </div>
    );
  }

  return children;
}
